import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Landing from '@pages/Landing'
import TOS from '@pages/TOS'
import SignUp from '@pages/SignUp'
import FindId from '@pages/FindId'
import FindPassword from '@pages/FindPassword'

const LandingRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/tos" element={<TOS />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/find-id" element={<FindId />} />
      <Route path="/find-password" element={<FindPassword />} />
    </Routes>
  )
}

export default LandingRouter
